<template>
    <Layout>
        <Sider width="220" :class="!isjxt?'sidebar':'sidebar_g1'" collapsible :collapsed-width="30" :hide-trigger="true" v-model="isCollapsed" ref="lSider" @on-collapse="changestate" :style="{background:treeDisp?'#F0F4FA':'#F0F4FA',borderRight:'1px solid #e8eaec'}">
            <Button type="text" @click="toggle" icon="ios-menu" :style="{width:'100%',
      borderRadius:'0px',
      boxShadow:'none',
      color:'white',
      background:'dodgerblue',
      display:leftTreeToggleMenuBtn?'block':'none'}" size="small"></Button>
            <MyAsideMenu ref="myAsideMenu" @OnSelectChange="showmap" @OnLocalSelectChange="showmap" @OnCardSwitch="rangeSwitch" @refreshMap="flashMap" @onCityChanged="showLocal" :style="{width:'100%',display:treeDisp?'block':'none'}"></MyAsideMenu>
        </Sider>
        <Layout style="position: relative;">
            <Content class="content">
                <div style="padding-left: 5px;">
                    <MyRoadMap ref="myroad" style="margin: 0px 0px;"></MyRoadMap>
                </div>
                <!--  <FileRange :style="{display:rangehidden?'none':'block'}"></FileRange> -->
                <div style="height: auto;">
                    <router-view v-if="isRouterAlive"></router-view>
                </div>
            </Content>
            <Spin fix v-if="isContentSHow"></Spin>
        </Layout>
    </Layout>
</template>
<script>
import Vue from 'vue'
import AsideMenu from './../aside_menu.vue'
import RoadMap from './../road_map'
import filerange from './local/range.vue'
import store from '../../store'
import eventBus from "../common/event_bus.js"
export default {
    name: 'SearchMain',
    inject: ["setTopMenuStyle","getSliders"],
    data() {
        return {
            isRouterAlive: false,
            rangehidden: true, //是否显示适用范围
            isCollapsed: false,
            leftTreeToggleMenuBtn: true,
            treeDisp: true,
            isContentSHow: false,
            localTreeNodeId: '',
            localSearchParameter: {
                classid: '',
                city: []
            },
            isjxt:store.state.user.isjxt,//false 不显示header，true显示header
        }
    },
    provide() {
        return {
            reload: this.reload,
            showMain: this.show,
            localTreeId: this.localTreeNodeId,
            topSearchParameter: this.localSearchParameter,
            sliders:this.getSliders(),
        }
    },
    methods: {
        flashMap(maps) {
            this.$refs.myroad.listen(maps);
        },
        showmap(maps, tabValue, cityValue) {
            console.log(maps, tabValue)
            var id = "";
            var selectNode = null
            var len
            if (maps !== undefined && maps.length > 0) {
                len = maps.length
            }
            if (maps[len - 1].node !== null) {
                selectNode = maps[len - 1].node
                id = selectNode.value
            }
            console.log("showmap id:" + id)
            this.$refs.myroad.listen(maps);
            if (tabValue === "1") {
                //console.log("show map 全国版...")
                this.$router.push({
                    name: 'search',
                    query: {
                        // classid: maps[len - 1].id,
                        classid: id,
                    }
                })
                this.reload()
            } else if (tabValue === "2") {
                console.log('show map 地方版...')
                this.localTreeNodeId = id
                // console.log('searchMain.push')
                // console.log(cityValue,id)

                // this.$router.push({
                //   name: 'localindex',
                //   query: {
                //     classid: id,
                //     province:cityValue[0],
                //     city:cityValue[1],
                //   },
                // })

                // this.$router.push({
                //   name: 'localindex',
                //   query: {
                //     classid: id,
                //     city:cityValue
                //   },
                // })
                //点击地方版树节点的事件
                let params = {
                    classid: id,
                    city: cityValue
                }
                this.localSearchParameter = params
                // console.log("showmap-localtree-select---->city components")
                //console.log(this.localSearchParameter)
                // eventBus.$emit("on-localTree-selected", params)
                eventBus.$emit("city-select", this.localSearchParameter)

            }

            //this.reload()
        },
        //城市切换时的事件
        showLocal(cityData) {
            console.log('showLocal99===============>')
            //console.log(cityData)
            this.localSearchParameter.classid = ''
            this.localSearchParameter.city = cityData
            this.$refs.myroad.reset()
            eventBus.$emit("city-select", this.localSearchParameter, true)
            //eventBus.$emit("city-select", this.localSearchParameter)

        },
        reload() {
            this.isRouterAlive = false
            //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        },
        show(value) {
            this.isContentSHow = value
        },
        //适用范围显示控制
        rangeSwitch(name) {
            if (name === "1") {
                //console.log('go to 1..')
                this.rangehidden = false;
                this.gotoRoute("search")
                this.$refs.myAsideMenu.init()
                //强制刷新
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true))
            } else {
                this.localSearchParameter.classid = ""
                this.localSearchParameter.city = []
                console.log('go to 2..')
                // this.rangehidden = true;
                this.gotoRoute("localindex")
                //更新顶部菜单默认样式
                this.setTopMenuStyle()

                //强制刷新
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true))
            }
        },
        gotoRoute(rName) {
            this.$router.push({
                name: rName,
                query: {
                    classid: 0,
                }
            })
        },
        toggle() {
            this.$refs.lSider.toggleCollapse()
        },
        changestate(state) {
            this.treeDisp = !state;
            store.commit('setLeftExpand', this.treeDisp)
        },
    },
    components: {
        'MyAsideMenu': AsideMenu,
        'MyRoadMap': RoadMap,
        'FileRange': filerange,
    }
}
</script>
<style lang="less" scoped>
.sidebar {
    background: #fff;
    overflow: auto;
    transition: width .2s ease .2s; //无过度动画
    // Height: 81.8vh;
    height: 89.5vh;

}

.sidebar_g1 {
    background: #fff;
    overflow: auto;
    transition: width .2s ease .2s; //无过度动画
    // Height: 81.8vh;
    height: 95.5vh;

}

.content {
    padding: 0 0 0 10px;
    background: #F7F9FA;
}
</style>